import React, { useEffect } from "react";
import "../styles/FallingBricks.css";

const FallingBricks = () => {
  useEffect(() => {
    const container = document.querySelector(".falling-bricks-container");

    function createBrick() {
      const brick = document.createElement("div");
      brick.className = "brick";
      brick.textContent = "🧱";
      brick.style.left = Math.random() * 100 + "vw";
      brick.style.animationDuration = 2 + Math.random() * 3 + "s";
      brick.style.fontSize = 16 + Math.random() * 24 + "px";
      container.appendChild(brick);

      setTimeout(() => container.removeChild(brick), 5000);
    }

    const interval = setInterval(createBrick, 300);

    return () => clearInterval(interval); 
  }, []);

  return <div className="falling-bricks-container"></div>;
};

export default FallingBricks;